import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  root:{
    maxWidth: 540,
    heigth: 540,
    width: '100%'
  },
  media: {
    height: 540
  },
});

export default useStyles;